import { render, staticRenderFns } from "./TeammateWidget.vue?vue&type=template&id=7bbfb139&scoped=true&"
import script from "./TeammateWidget.vue?vue&type=script&lang=js&"
export * from "./TeammateWidget.vue?vue&type=script&lang=js&"
import style0 from "./TeammateWidget.vue?vue&type=style&index=0&id=7bbfb139&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfb139",
  null
  
)

export default component.exports